import React, { useEffect, useState } from 'react'
import { MenuItem, Button, Select } from '@mui/material'
import "./EditList.css"
import axiosApiInstance from '../axios';


const EditList = ({ info, onStChange }) => {

  const [assign, setAssign] = useState([])
  const [assignId, setAssignId] = useState(0)

  const [ticketId, setTicketId] = useState([])


  useEffect(() => {
    // add axios here
    axiosApiInstance.get(`/ticket/${info}`)
      .then(res => setTicketId((res.data.data))
      ).catch(err => console.log(err))
  }, [info])


  useEffect(() => {
    // add axios here
    axiosApiInstance.get(`/assign`)
      .then(res => setAssign((res.data.data))
      ).catch(err => console.log(err))
  }, [])

  const inputEvent = (event) => {
    setAssignId(event.target.value)
  };

  let data = JSON.stringify({
    "ticketId": info,
    "assignId": assignId === 0 ? ticketId.assignId : assignId,
  });

  const fetchedToken = localStorage.getItem('token');

  const saveDetails = () => {

    axiosApiInstance.post('/ticket/UpdateTicketAssign', data).then(function (response) {
      console.log(JSON.stringify(response.data));
    })
    onStChange();

  }


  return (
    <>
      <div className="edit">
        <Select className="sel_category-2"
          displayempty
          name="assign"
          value={assignId}
          onChange={inputEvent}
        >
          <MenuItem value="0" disabled>Add Assignee</MenuItem>
          {assign.map((cat, id) => (
            <MenuItem key={id} value={cat.id}>{cat.fullName}</MenuItem>
          ))
          }
        </Select>

      </div>
      <div className="btn-asg">
        <Button className="edit-save" onClick={saveDetails}>Save</Button>
        <Button className="edit-cancel" onClick={onStChange}>Cancel</Button>
      </div>
    </>
  )
}
export default EditList;